import { Box, Button, Typography } from "@mui/material";
import { ACCENT } from "./constants";

function EmptyState({ onClear }) {
  return (
    <Box sx={{ textAlign: "center", py: 8 }}>
      <Typography sx={{ color: "#aaa" }}>No items match your search.</Typography>
      <Button variant="text" onClick={onClear} sx={{ mt: 1, textTransform: "none", color: ACCENT }}>
        Clear filters
      </Button>
    </Box>
  );
}

export default EmptyState;